export const supportData = [
    {
        title:"Developer resources",
        description:"Get limitless access to the Unity User Manual, or search through common technical issues in our Knowledge Base. Unity’s Developer Tools is a free comprehensive resource available to all Unity users looking to solve technical issues on their own.",
        imageUrl:"support/dev-resources.webp",

    },
    {
        title:"Premium support",
        description:"Accelerate your project, resolve issues quickly, and mitigate risks with a selection of fee-based Premium Success Plans. Get direct access to Unity strategic advisors who will assist you with Unity Editor, Reflect, Forma, Build Server, and more.",
        imageUrl:"support/premium-support.webp",
        
    },
    {
        title:"Game services support",
        description:"Access the Gaming Services Dashboard, a support hub for products such as Unity Ads, Unity Cloud Build, UDP, Vivox, Multiplay, deltaDNA, GameTune and more. Read documentation, watch videos and access support for each product.",
        imageUrl:"support/game-services-support.webp",
        
    }
]

export const consultData= [
    {
        title:"Gaming solutions",
        description:"Unity’s Accelerate Solutions - Games helps studios push the boundaries of game play. Choose from our flexible consulting options and add our technical expertise to your team to optimize your game performance, overcome roadblocks and improve player experience.",
        imageUrl:"support/gaming-solutions.jpg",
        
    },
    {
        title:"Industry solutions",
        description:"Unity’s Accelerate Solutions - Industry helps companies across multiple industries innovate faster. Harnessing the advanced digital technologies at the forward edge of business transformation, we build custom solutions that empower enterprises to embrace innovation and take the lead.",
        imageUrl:"support/industry-solutions.webp",
        
    }
]